import { useEffect, useState, useCallback } from "react";
import { Table, Card, Grid, List, Row, Col } from "antd";
import { supabase } from "../supabaseClient";
import dayjs from "dayjs";
import { FilterBar } from "../components/FilterBar";
import StatusBadge from "../components/StatusBadge";
import { useLoading } from "../contexts/LoadingContext";

export default function ManagePage() {
  const [requests, setRequests] = useState([]);
  const [filters, setFilters] = useState({ date: null, status: null });
  const { useBreakpoint } = Grid;

  const { setLoading } = useLoading();

  const screens = useBreakpoint();
  const isMobile = !screens.md;




  // const fetchData = useCallback(async (customFilters = filters) => {
  //   setLoading(true);
  //   let query = supabase
  //     .from("don_tham_quan_nhan")
  //     .select("*")
  //     .order("created_at", { ascending: false });

  //   if (customFilters.date) {
  //     query = query.eq("ngay_tham", customFilters.date.format("YYYY-MM-DD"));
  //   }

  //   if (customFilters.status) {
  //     query = query.eq("status", customFilters.status);
  //   }

  //   if (customFilters.name) {
  //     // nếu muốn tìm gần đúng thì dùng ilike (case-insensitive)
  //     query = query.ilike("ten_quan_nhan", `%${customFilters.name}%`);
  //   }

  //   const { data } = await query;
  //   setRequests(data || []);
  //   setLoading(false);
  // }, [filters, setLoading]);

    const fetchData = useCallback(async (customFilters) => {
  setLoading(true);
  let query = supabase
    .from("don_tham_quan_nhan")
    .select("*")
    .order("created_at", { ascending: false });

  if (customFilters?.date) {
    query = query.eq("ngay_tham", customFilters.date.format("YYYY-MM-DD"));
  }

  if (customFilters?.status) {
    query = query.eq("status", customFilters.status);
  }

  if (customFilters?.name) {
    query = query.ilike("ten_quan_nhan", `%${customFilters.name}%`);
  }

  if (customFilters?.don_vi) {
    query = query.ilike("don_vi", `%${customFilters.don_vi}%`);
  }

  const { data } = await query;
  setRequests(data || []);
  setLoading(false);
}, [setLoading]); // bỏ filters khỏi dependency

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    { title: "Quân nhân", dataIndex: "ten_quan_nhan" },
    { title: "Đơn vị", dataIndex: "don_vi" },
    { title: "Người thân", dataIndex: "ten_nguoi_than" },
    { title: "Số điện thoại", dataIndex: "so_dien_thoai" },
    {
      title: "Ngày thăm",
      dataIndex: "ngay_tham",
      render: (v) => dayjs(v).format("DD/MM/YYYY"),
    },
    {
      title: "Giờ ra thăm",
      dataIndex: "gio_ra_tham",
      render: (v) => (v ? dayjs(v).format("HH:mm") : "--"),
    },
    {
      title: "Giờ vào lại đơn vị",
      dataIndex: "gio_vao_lai_don_vi",
      render: (v) => (v ? dayjs(v).format("HH:mm") : "--"),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (status) => <StatusBadge status={status} />,
    },
  ];

  return (
    <Card title="DANH SÁCH ĐƠN ĐĂNG KÝ THĂM QUÂN NHÂN">
      <Row gutter={[8, 8]} style={{ marginBottom: 12 }}>
        {/* Filter */}
        <Col xs={24} md={18}>
          <FilterBar
            filters={filters}
            setFilters={setFilters}
            onFilter={fetchData}
          />
        </Col>
      </Row>

      {!isMobile ? (
        <Table
          rowKey="id"
          columns={columns}
          dataSource={requests}
          rowClassName={(record) => `row-${record.status}`}
          pagination={{
            pageSize: 12,
          }}
        />
      ) : (
        <List
          dataSource={requests}
          pagination={{ pageSize: 12 }}
          renderItem={(item) => (
            <Card style={{
              marginBottom: 12, backgroundColor: "#f9f9f9", border: "1px solid #e0e0e0",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}>
              <p><b>Quân nhân:</b> {item.ten_quan_nhan}</p>
              <p><b>Đơn vị:</b> {item.don_vi}</p>
              <p><b>Người thân:</b> {item.ten_nguoi_than}</p>
              <p><b>Số điện thoại:</b> {item.so_dien_thoai}</p>
              <p><b>Ngày:</b> {item.ngay_tham}</p>
              <p>
                <b>Giờ ra thăm:</b>{" "}
                {item.gio_vao_lai_don_vi ? dayjs(item.gio_vao_lai_don_vi).format("HH:mm") : "--"}
              </p>
              <p>
                <b>Giờ vào lại đơn vị:</b>{" "}
                {item.gio_vao_lai_don_vi ? dayjs(item.gio_vao_lai_don_vi).format("HH:mm") : "--"}
              </p>

              <p style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <b>Trạng thái:</b>
                <StatusBadge status={item.status} />
              </p>

            </Card>
          )}
        />
      )}

    </Card>
  );
}
